export function getFeatures(app) {
  let list = [
    ...(app.launchers || []),
    ...(app.automations || []),
    ...(app.displays || []),
    ...(app.features || []),
    app.sync
      ? {
          description: `Bulk sync patients to simplify onboarding and link records between systems`,
        }
      : null,
  ].filter(item => item?.description)

  return list.length === 0
    ? [
        {
          description:
            'Access your data securely through the Greyfinch Connect API',
        },
      ]
    : list
}
